﻿import { rootElement } from '@shared/setup';
import DomainWhitelists from '@cwd/Account/DomainWhitelists/DomainWhitelists.vue';

const initDomainWhitelists = async () => {
    rootElement({
        name: 'domain-whitelists', // pascal, camel & kebab-case are valid
        component: DomainWhitelists,
        vm: {},
        contextComponents: ['<div>waiting</div>'],
    });
};
initDomainWhitelists();
